var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7063 8.70624C14.0969 8.31562 14.0969 7.68124 13.7063 7.29062L8.70625 2.29062C8.31563 1.89999 7.68125 1.89999 7.29063 2.29062C6.9 2.68124 6.9 3.31562 7.29063 3.70624L10.5875 6.99999H1C0.446875 6.99999 0 7.44687 0 7.99999C0 8.55312 0.446875 8.99999 1 8.99999H10.5844L7.29375 12.2937C6.90312 12.6844 6.90312 13.3187 7.29375 13.7094C7.68437 14.1 8.31875 14.1 8.70938 13.7094L13.7094 8.70937L13.7063 8.70624Z",
    fill: "#8A9BFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPurple);
export default __webpack_public_path__ + "static/media/arrow-purple.666d5325c9d550cc7b4668afe449bdc6.svg";
export { ForwardRef as ReactComponent };